export const findElementAboveByClass = (element, className) => {
  while (true) {
    const classes = element.className.split(' ')
    if (classes.includes(className)) return element
    else if (element === document.body) return null
    else element = element.parentElement
  }
}

export const preventProcessingLinks = (e) => {
  const targetLink = e.target.closest('a')
  if (!targetLink) return
  e.preventDefault()
}

export const openIronscalesNewTab = (url, dry = false) => {
  if (dry) return window.location.origin + url
  window.open(window.location.origin + url, '_blank')
}

export const openInNewTab = (url) => {
  window.open(url, '_blank')
}
